import { Story } from '../../types/story';

export const amsterdamTriangle: Story = {
  id: 'amsterdam-triangle',
  title: 'The Canal House',
  excerpt: 'An American couple on vacation in Amsterdam meets a Dutch artist who shows them that desire doesn\'t follow rules, especially not in a city where anything goes and everyone wants something they shouldn\'t.',
  city: 'Amsterdam',
  publishDate: '2026-01-12',
  readTime: '32 min read',
  tags: ['♂♀♂', 'bisexual', 'intense', 'humiliation', 'power'],
  categories: ['intense', 'queer'],
  intensity: 3,
  content: `The problem with Amsterdam is that it makes you believe anything is possible.

We'd been there three days—me, Sarah, and the promise of a romantic getaway to fix our marriage. And it was working, sort of. We'd walked the canals, visited the museums, eaten too much cheese. But the real Amsterdam, the one that whispered in your ear at night, was still waiting.

That's when we met him.

Lars was exactly what you'd picture a Dutch artist to be—tall, blond, blue eyes that seemed to see through you, wearing paint-splattered jeans and a black t-shirt that showed off lean muscles. We were in a tiny gallery in the Jordaan, looking at paintings that were too abstract for my taste, when he approached us.

"You're American," he said, his English perfect. "You're looking at my work like you're trying to understand it."

"We're trying," Sarah said, laughing. "I'm Sarah, this is Mark."

"Lars. And you don't need to understand it. You just need to feel it."

He was looking at Sarah when he said it, but then his eyes shifted to me, and something passed between us. An acknowledgment. A question.

"The way you look at your wife," Lars said quietly. "Like she's something precious you're afraid to break."

I felt my face heat up. "I love her."

"I know. But love isn't the same as desire, is it?"

Sarah was watching us now, her expression curious. "What do you mean?"

Lars smiled, slow and dangerous. "I mean that sometimes what we think we want isn't what we actually need. Sometimes we need someone to show us."

"Show us what?" I asked, though I was afraid I already knew.

"The truth."

That night, we went back to his place. A canal house in the center of the city, all exposed brick and high ceilings and paintings that covered every wall. The kind of place that felt like it had stories to tell.

"Wine?" Lars asked, already moving toward the kitchen.

"Please," Sarah said, sinking onto a leather sofa. "This place is incredible."

"It's been in my family for generations. Artists, mostly. We're good at collecting things. Art. Stories. People."

He came back with three glasses of red wine, sat down across from us. The air was thick with tension, with possibility.

"So," Sarah said, swirling her wine. "What truth were you talking about earlier?"

Lars looked at me first, then at her. "The truth about desire. About how it doesn't follow rules. About how sometimes the people we think we want aren't the only people we can want."

I should have stopped it right there. Should have taken Sarah's hand and walked out. But I didn't. Because I was curious. Because I'd been wondering the same thing for years.

"Are you suggesting what I think you're suggesting?" Sarah asked, her voice steady.

"I'm suggesting that we're all adults here. That we're all curious. That Amsterdam is the perfect place to explore things we wouldn't dare to explore at home."

"And what if we don't want to explore?" I asked.

"Then you leave. No harm, no foul." Lars leaned forward, his eyes locked on mine. "But I think you do want to explore. I think you've wanted to explore for a long time."

He was right. I had. But I never thought Sarah would agree.

"Mark?" Sarah asked, turning to me. "What do you think?"

I looked at my wife—beautiful, brave, Sarah—and saw the same curiosity in her eyes that I felt. The same hunger.

"I think... I think I'm curious too."

That was all it took.

Lars stood up, held out his hands to both of us. "Then let's explore."

He led us to his bedroom—a massive space with a king-sized bed that looked like it belonged in a castle, floor-to-ceiling windows overlooking the canal.

"The rules," he said, his voice low and serious. "Everything is consensual. Everything is safe. But everything is also honest. No pretending. No hiding what you want."

"Okay," Sarah said, her voice barely a whisper.

"Good." Lars turned to me. "Mark. Take off your clothes."

I hesitated for a second, then started unbuttoning my shirt. Sarah watched, her eyes wide, as I stripped down to my boxers.

"Everything," Lars said.

I pushed the boxers down, and I was completely naked in front of them. Sarah had seen me naked a thousand times, but this was different. Lars was watching me, his eyes moving over my body like he was assessing me.

"Turn around," he commanded.

I did, my face burning with embarrassment.

"Look at him," Lars said to Sarah. "Look at how hard he is already. How desperate."

I was hard, yes, but not as hard as I should have been. Not as big as I wanted to be.

"Mark has always been... insecure," Sarah said quietly. "About his size."

"Size doesn't matter," Lars said, but his tone suggested otherwise. "What matters is how you use what you have. And right now, Mark, you're not using anything. You're just standing there, looking pathetic."

The words hit me like a physical blow. My cock, which had been hardening, started to soften.

"See?" Lars said. "He can't even stay hard when his wife watches. That's sad, really."

"Please," I whispered.

"Please what? Please stop telling the truth? Please stop pointing out that you're not man enough to satisfy your wife? That she deserves better?"

Sarah was watching us, her breathing heavy, her hand moving between her legs.

"She does deserve better," I admitted, the words tearing out of me. "She deserves someone who can actually please her."

"Like me?" Lars asked, already unbuttoning his jeans.

He was bigger than me. Not just taller, but thicker, more muscular. And when he pulled down his jeans, I saw that he was bigger there too. Much bigger.

"Oh God," Sarah breathed.

"Exactly," Lars said, a smirk playing on his lips. "Now you see what a real man looks like."

He moved toward Sarah, pulled her to her feet, started undressing her. I stood there, naked and small, watching another man touch my wife.

"You like that, don't you?" Lars asked Sarah, his hands on her breasts. "You like knowing what you've been missing."

"Yes," she gasped. "God, yes."

"Then get on the bed. On your hands and knees."

Sarah obeyed, positioning herself on the bed, her ass in the air, looking back at us.

"Mark," Lars said. "Come here."

I moved closer, my heart pounding.

"Kneel," he commanded.

I knelt beside the bed.

"Now watch," he said. "Watch how a real man pleases a woman."

He positioned himself behind Sarah, and I watched as he entered her. She cried out, a sound I'd never heard from her before—pure, unadulterated pleasure.

"Harder," she begged. "Please, harder."

Lars gave her what she wanted, his hips snapping forward, the sound of skin slapping skin filling the room. Sarah was moaning, crying out, completely lost in it.

"Look at her," Lars said to me. "Look how much she's enjoying this. Look how responsive she is when she's actually being satisfied."

I watched, my own cock hardening despite the humiliation. Despite the shame.

"Touch yourself," Lars commanded. "Show me how much this turns you on."

I wrapped my hand around my cock, started stroking. I was smaller than him, I knew that, but I was hard, and the shame was mixing with arousal in a way I didn't understand.

"That's it," Lars said, his rhythm never faltering. "Stroke your little cock while I fuck your wife. Show her what a pathetic excuse for a man you are."

Sarah was watching me now, her eyes dark with desire. "He's so small," she gasped. "So pathetic."

"He is," Lars agreed. "But he's learning his place, aren't you, Mark?"

"Yes," I moaned. "I'm learning."

"Good boy."

Lars pulled out of Sarah, turned her over onto her back. "Now I want you to watch me come inside her. I want you to see what a real man's cum looks like."

He entered her again, and this time he was rougher, more demanding. Sarah was writhing beneath him, her nails digging into his back, her cries getting louder.

"Come with me," he commanded. "Both of you. Mark, come on your hand. Sarah, come on my cock."

Sarah came first, her body arching off the bed, her cries echoing in the room. I followed seconds later, my release spilling over my hand, the shame and pleasure mixing until I couldn't tell them apart.

Lars came last, burying himself deep with a groan, his body tensing as he filled her.

We lay there for a moment, the three of us tangled together, the air thick with the smell of sex and sweat.

"Now you know," Lars said quietly. "Now you both know what you've been missing."

Sarah was the first to move, rolling over to face me. "Was that... okay?"

"It was... intense," I admitted.

"Did you like it?" she asked, her voice soft.

"I... I think so."

Lars laughed, low and dark. "Oh, you liked it. You loved it. You loved watching me fuck your wife. You loved feeling small and pathetic. You loved every second of it."

I couldn't deny it.

"And you," he said to Sarah. "You loved having a real man inside you. You loved knowing you could finally get what you deserve."

"Yes," she whispered. "I did."

"Good," Lars said. "Because we're not done yet."

He pulled me up, pushed me onto the bed next to Sarah. "Now it's your turn, Mark. Your turn to show us what you can do."

"What do you want me to do?"

"I want you to eat her pussy while I watch," Lars said. "I want you to taste my cum inside her. I want you to clean her up."

I hesitated for a second, then moved between Sarah's legs. She was wet, swollen, and I could see Lars's cum leaking out of her.

"Go on," Lars commanded. "Taste it."

I leaned in, my tongue finding her clit, and I tasted him—salty, masculine, undeniable. Sarah moaned, her hands finding my hair, and I lost myself in it, in the shame and the pleasure, in the knowledge that I was exactly where I belonged.

"Good boy," Lars said. "Now make her come. Show me you can at least do that right."

I worked her with my mouth, my tongue, my fingers, and when she came, her body clenching around my fingers, her cries filling the room, I felt a surge of pride despite everything.

"Very good," Lars said approvingly. "Now it's my turn again."

He positioned himself behind me, and I tensed.

"Relax," he murmured. "I'm not going to hurt you. I'm going to show you what it feels like to be taken."

He used lube—lots of it—and when he entered me, it burned at first, then something else. Something I'd never felt before. Full. Stretched. Used.

"Fuck," I gasped.

"That's it," he said, his voice low. "Take it. Take all of me."

He moved slowly at first, letting me adjust, then faster, harder. Sarah was watching us, her eyes wide, her hand between her legs.

"You like this, don't you?" she asked. "You like being fucked like a girl."

"Yes," I moaned. "God, yes."

"Tell him you want it," Lars commanded. "Tell me you want me to fuck you."

"I want it," I gasped. "Please, fuck me. Please."

And he did, hard and deep, until I was crying out with each thrust, until I was completely lost in it, in the pleasure and the pain and the shame.

"Come for me," he commanded. "Come while I'm inside you."

I did, my release hitting me like a physical force, my body arching off the bed. He followed me over the edge, burying himself deep with a groan.

We lay tangled together afterward, all three of us, our bodies slick with sweat and cum.

"Now you know," Lars said quietly. "Now you both know what you really want."

Sarah kissed me, soft and sweet. "Are you okay?"

"I'm better than okay," I admitted. "I'm... free."

"Free?"

"Free from pretending. Free from trying to be something I'm not."

Lars kissed us both, first Sarah, then me. "Good. Because pretending is boring. The truth is much more interesting."

We stayed the night, all three of us in his bed, exploring every possibility, every desire. And in the morning, when we left his canal house, we were different people.

Sarah and I went back to our hotel, packed our bags, and flew home. But we weren't the same couple who had arrived in Amsterdam. We were honest now. About what we wanted, about who we were.

And sometimes, when we're lying in bed at night, Sarah will whisper, "Remember Amsterdam?" and I'll smile, because how could I forget?

How could I forget the night I learned that shame could be pleasure, that humiliation could be freedom, that love wasn't about possession but about honesty?

How could I forget Lars, and the canal house, and the truth that Amsterdam had shown us?

Some truths, once learned, can't be unlearned.

And some desires, once awakened, can't be ignored.`
};
